export const SETORES_OPERACIONAIS = [
  { titulo: "Comunicação", itens: [{ texto: "Comunicação", tela: "mensagensOperacionais" }] },
  {
    titulo: "Engenharia",
    itens: [
      { texto: "Diario de Obra (RDO)", tela: "diarioObra" },
      { texto: "Producao de Campo / Croqui", tela: "producaoCampo" }
    ]
  },
  { titulo: "Manutenção", itens: [{ texto: "Manutenção de Equipamentos", tela: "manutencao" }] },
  {
    titulo: "Transporte",
    itens: [
      { texto: "Lancamento Diario de Equipamento", tela: "lancamento" },
      { texto: "Romaneio de Transporte", tela: "transportes" },
      { texto: "Receber Transporte (QR)", tela: "receberTransporte" },
      { texto: "Receber Transferencia (QR)", tela: "receberTransferencia" }
    ]
  },
  {
    titulo: "Almoxarifado",
    itens: [
      { texto: "Abastecimento", tela: "abastecimento" },
      { texto: "Saidas de Materiais (Almox/EPI)", tela: "materiaisSaidas" }
    ]
  }
];

export const SETORES_ADMINISTRATIVOS = [
  {
    titulo: "Engenharia",
    itens: [
      { texto: "Relatorio Producao de Campo / Croqui", tela: "relatorioProducaoCampo" },
      { texto: "Relatorio Diario de Obra (RDO)", tela: "relatorioDiarioObra" }
    ]
  },
  { titulo: "Manutenção", itens: [{ texto: "Relatório de Manutenção", tela: "relatorioManutencao" }] },
  {
    titulo: "Transporte",
    itens: [
      { texto: "Relatorio Mensal de Equipamento", tela: "relatorio" },
      { texto: "Romaneio de Transporte", tela: "transportes" },
      { texto: "Relatorio de Transportes", tela: "relatorioTransportes" },
      { texto: "Boletim de Transferencia", tela: "transferencias" }
    ]
  },
  {
    titulo: "Almoxarifado",
    itens: [
      { texto: "Entrada de Materiais (Central)", tela: "almoxarifado" },
      { texto: "Medição de Tanques", tela: "medicaoTanques" },
      { texto: "Relatorio de Abastecimento", tela: "relatorioAbastecimento" }
    ]
  },
  {
    titulo: "Cadastros",
    itens: [
      { texto: "Bases (UF/Cidades)", tela: "bases" },
      { texto: "Obras", tela: "obras" },
      { texto: "Equipamentos", tela: "equipamentos" },
      { texto: "Usuarios Operacionais", tela: "frentistas" },
      { texto: "Funcionarios", tela: "funcionarios" },
      { texto: "Empresas Requisitantes", tela: "empresas" },
      { texto: "Cadastro da Empresa", tela: "configEmpresa" }
    ]
  },
  {
    titulo: "Administrativo Financeiro",
    itens: [
      { texto: "Configuracoes Financeiras", tela: "financeiro" },
      { texto: "Pedido de Compra", tela: "pedidoCompra" },
      { texto: "Boletim de Medicao", tela: "boletimMedicao" },
      { texto: "Comunicação", tela: "mensagensOperacionais" },
      { texto: "Memorando Interno", tela: "memorandoInterno" },
      { texto: "Historico", tela: "historico" }
    ]
  }
];

export function obterSetorDaTela(tela, modo = "operacional") {
  const setores = modo === "administrativo" ? SETORES_ADMINISTRATIVOS : SETORES_OPERACIONAIS;
  return setores.find((setor) => setor.itens.some((item) => item.tela === tela)) || null;
}

export function obterAtalhosDoSetor(titulo, modo, nomes = {}) {
  const setores = modo === "administrativo" ? SETORES_ADMINISTRATIVOS : SETORES_OPERACIONAIS;
  const setor = setores.find((item) => item.titulo === titulo);
  return (setor?.itens || []).map((item) => ({ tela: item.tela, nome: nomes[item.tela] || item.texto }));
}
